import { useState } from "react";

export const useInvitations = () => {
  const [emailToInvite, setEmailToInvite] = useState("");
  const [invitationRole, setInvitationRole] = useState("");

  return { emailToInvite, setEmailToInvite, invitationRole, setInvitationRole };
};
